import { createFileRoute } from '@tanstack/react-router'
import { AssignmentsPage } from '../components/AssignmentsPage'

export const Route = createFileRoute('/assignments')({
    component: () => <AssignmentsPage />,
})

